import SettingsBotRow from './SettingsBotRow'

export default SettingsBotRow
